'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationResponseList', ['$scope', '$rootScope', '$window', 'FBResponses', 'Triggers', '$state', 'LicenseRequests', 'Documents',
        function ($scope, $rootScope, $window, FBResponses, Triggers, $state, LicenseRequests, Documents) {

            $scope.startResponse = function (response) {
                response.starting = true;
                var saveResponse = angular.copy(response);
                saveResponse.progress = 1;
                saveResponse.started_on = new Date();
                FBResponses.save(saveResponse, null, false).then(function (savedResponse) {
                    if (savedResponse.form.start_trigger_name != null && savedResponse.form.start_trigger_name != "") {
                        Triggers.fire({
                            name: savedResponse.form.start_trigger_name,
                            triggerID: savedResponse.form.start_trigger_id,
                            licenseRequestID: savedResponse.license_request_id
                        });
                    }
                    $state.go('internal.licensing.application.response', { responseID: response.id, response: response });
                    response.starting = false;
                });
            }

            $scope.continueResponse = function (response) {
                FBResponses.clearSignatures(response.id).then(function () {
                    $state.go('internal.licensing.application.response', { responseID: response.id, response: response });
                });
            }

            $scope.viewResponse = function (response) {
                $state.go('internal.licensing.application.response', { responseID: response.id, response: response });
            }
        
            $scope.reopen = function (array, response) {
                response.reopening = true;
                if (window.confirm('Are you sure you want to reopen this form?')) {
                    FBResponses.reopen(response.id, $scope.applicationID).then(function (success) {
                        if (success) {
                            Triggers.fire({
                                name: "Form recertified successfully",
                                licenseRequestID: $scope.applicationID
                            }).then(function () {
                                response.reopening = false;
                                $scope.getApplication();
                            });
                        }
                        else {
                            response.reopening = false;
                        }
                    });
                } else {
                    response.reopening = false;
                }
            }

            $scope.regenerate = function (array, r) {
                r.regenerating = true;
                if (window.confirm('Are you sure you want to regenerate the PDF?  This will NOT fire any form completed/form condition triggers.')) {
                    FBResponses.getByID(r.id).then(function (response) {
                        if (response != null) {
                            var parameters = { response_id: r.id, license_request_id: response.license_request_id, license_id: response.license_id, user_id: response.user_id, service_id: response.service_id, vehicle_id: response.vehicle_id, child_service: response.child_service, default_license_category_id: response.license_category_id };
                            FBResponses.generatePDF(response, $scope.applicationID, parameters).then(function (document) {
                                r.regenerating = false;
                                $scope.getApplication();
                            })
                        }
                        else {
                            r.regenerating = false;
                        }
                    });                
                }
                else {
                    r.regenerating = false;
                }
            }

            $scope.remove = function (array, response) {
                response.removing = true;
                if (window.confirm('Are you sure you want to remove this form?')) {
                    FBResponses.delete(response.id).then(function () {
                        updateArray(array, response, true);
                        $scope.setMasterApplication($scope.application);
                    });
                } else {
                    response.removing = false;
                }
            }

            $scope.getXML = function () {
                $scope.downloading = true;
                LicenseRequests.getXML($scope.applicationID).then(function (xml) {
                    var blob = new Blob([xml], { type: "text/xml" });

                    if (navigator.userAgent.toString().indexOf('.NET') > 0 || navigator.userAgent.toString().indexOf('Edge') > 0) {
                        window.navigator.msSaveBlob(blob, 'application.xml');
                    }
                    else {
                        var downloadLink = angular.element('<a></a>');
                        downloadLink.attr('href', window.URL.createObjectURL(blob));
                        downloadLink.attr('download', 'application.xml');
                        document.body.appendChild(downloadLink[0]);
                        downloadLink[0].click();
                        document.body.removeChild(downloadLink[0]);
                    }
                    $scope.downloading = false;
                });
            }        

            $scope.viewPdf = function (response) {
                Documents.logAccess(response.document_id);
                if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                    $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + response.document_id.toUpperCase() + '&code=' + response.document_code, '_blank');
                }
                else {
                    $window.open($rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + response.document_id.toUpperCase() + '&code=' + response.document_code, '_blank');
                }
            }

            $rootScope.$on('generate:pdf', function () {
                $rootScope.generatingPDF = true;
            });

            $rootScope.$on('reset:application', function () {
                $rootScope.generatingPDF = false;
                $scope.loadApplication(); 
            });

            window.onbeforeunload = function (e) {
                if ($rootScope.generatingPDF) {
                    var message = "", e = e || window.event;
                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }

                    // For Safari
                    return message;
                }
            };
        }])
    .directive('internalApplicationResponseList', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'applications/components/application-response-list/application-response-list.html',
            replace: true,
            controller: 'InternalApplicationResponseList'
        };
    }])
;
